"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setProcessTitle = (appName) => {
    process.title = `osmosys-${appName}`;
    process.stdout.write(String.fromCharCode(27) + ']0;' + process.title + String.fromCharCode(7));
};
//# sourceMappingURL=setProcessTitle.js.map